<template>
  <div class="labeled-vehicle-model-list">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <VehicleModelList
      ref="vehicleModelList"
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :options="options"
      :is-disabled="isDisabled"
      :is-loading="isLoading"
      :empty-text="emptyText"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </VehicleModelList>
  </div>
</template>

<script>
import { default as VehicleModelList } from '../vehicle-model-list';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    label: {
      type: String,
      default: 'Оберіть марку транспортного засобу зі списку',
    },
    options: {
      type: Array,
      default: () => [],
      validator: (value) => {
        return value.every(item =>
          item && typeof item === 'object' &&
          'id' in item && 'name' in item
        );
      },
    },
    placeholder: {
      type: String,
      default: 'Виберіть модель транспортного засобу',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: 'Спочатку виберіть марку',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputId: `vehicle-make-list-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, VehicleModelList },
  computed: {
    getVehicleModelListSelect() {
      return this.$refs.vehicleModelList;
    }
  },
  methods: {
    generateRandomId,
  },
};
</script>
